import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Grid"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "grid"
    }}>{`Grid`}</h1>
    <p>{`CSS grid layout component to arrange direct child elements in a tiled grid layout.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`import { Grid } from 'theme-ui'
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live=true",
        "live": "true"
      }}>{`<Grid width={[128, null, 192]}>
  <Box bg="primary">Box</Box>
  <Box bg="muted">Box</Box>
  <Box bg="primary">Box</Box>
  <Box bg="muted">Box</Box>
</Grid>
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live=true",
        "live": "true"
      }}>{`<Grid gap={2} columns={[2, null, 4]}>
  <Box bg="primary">Box</Box>
  <Box bg="muted">Box</Box>
  <Box bg="primary">Box</Box>
  <Box bg="muted">Box</Box>
</Grid>
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live=true",
        "live": "true"
      }}>{`<Grid gap={2} columns={[2, '1fr 2fr']}>
  <Box bg="primary">Box</Box>
  <Box bg="muted">Box</Box>
  <Box bg="primary">Box</Box>
  <Box bg="muted">Box</Box>
</Grid>
`}</code></pre>
    <h2 {...{
      "id": "props"
    }}>{`Props`}</h2>
    <p>{`The `}<inlineCode parentName="p">{`Grid`}</inlineCode>{` component includes custom props for adjusting the grid layout.
Each prop can use the `}<a parentName="p" {...{
        "href": "/sx-prop#responsive-values"
      }}>{`responsive array`}</a>{` syntax for mobile-first responsive styles.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Prop`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`width`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Minimum width of child elements`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`gap`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Space between child elements`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`columns`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Number of (equally-sized) columns, or string with `}<a parentName="td" {...{
              "href": "https://developer.mozilla.org/en-US/docs/Web/CSS/grid-template-columns"
            }}>{`grid syntax`}</a>{` for the layout (cannot be used in conjunction with the `}<inlineCode parentName="td">{`width`}</inlineCode>{` prop)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`repeat`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Mode for column sizing, used in conjunction with the `}<inlineCode parentName="td">{`width`}</inlineCode>{` prop. Can either be `}<inlineCode parentName="td">{`fit`}</inlineCode>{` or `}<inlineCode parentName="td">{`fill`}</inlineCode>{` (`}<inlineCode parentName="td">{`fit`}</inlineCode>{` is default)`}</td>
        </tr>
      </tbody>
    </table>
    <h2 {...{
      "id": "variants"
    }}>{`Variants`}</h2>
    <p>{`You can define additional CSS grid layouts by adding variants to the `}<inlineCode parentName="p">{`theme.grids`}</inlineCode>{` object.
These styles can be used to create a wide variety of different reusable layouts.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      